import React, { useMemo,useContext, useEffect } from 'react';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import { useAuth } from '../../contexts/auth';
import './user-panel.scss';
import { useHistory } from "react-router-dom";
import {NavbarContext} from '../../contexts/top-navigation';
import sessions from '../../sessions';

export default function ({ menuMode }) {
  const { signOut } = useAuth();
  const history = useHistory();
  const menu = useContext(NavbarContext);
  const defaultAvatar = "https://www.dropbox.com/s/lve7qp6ro3kda0x/male_avatar.png";
  const uservatar = sessions.getSession("user");
  const avatar = uservatar?.avatarUrl?defaultAvatar:uservatar.avatarUrl.toString().split('?')[0];
  
  const menuItems = useMemo(() => ([
    {
      text: 'My Profile',
      icon: 'user',
      onClick: ()=>{menu.setMenuID("settings");history.push('/settings/my-profile')}
    },
    {
      text: 'Logout',
      icon: 'runner',
      onClick: signOut
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ]), []);

  return (
    <div className={'user-panel'}>
      <div className={'user-info'}>
        <div className={'image-container'}>
          <div
            style={{
              background: `url("${avatar}?raw=1") no-repeat #fff`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center'
            }}
            className={'user-image'} />
        </div>
      </div>

      {menuMode === 'context' && (
        <ContextMenu
          items={menuItems}
          target={'.user-button'}
          showEvent={'dxclick'}
          width={210}
          cssClass={'user-menu'}
        >
          <Position my={'top center'} at={'bottom center'} />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <List className={'dx-toolbar-menu-action'} items={menuItems} />
      )}
    </div>
  );
}
